export default __webpack_public_path__ + "static/media/disney-world.c82654d7.jpg";